// extracted by mini-css-extract-plugin
export var text = "_13-0";